<template>
    <a-modal title="查看催办意见"
             class="wf-modal"
             :destroyOnClose="true"
             :width="800"
             :footer="null"
             :visible="visible"
             @cancel="onClose"
             :confirmLoading="modalLoading">
        <div>
            <template>
                <a-list
                        class="comment-list"
                        :header="`共 ${urgenceListData.length} 条催办`"
                        item-layout="horizontal"
                        :data-source="urgenceListData"
                        :pagination="{pageSize: 5}"
                >
                    <!-- 催办记录-->
                    <a-list-item slot="renderItem" slot-scope="item, index" style="background-color: rgba(236, 243, 249, 1);">
                        <div class="ant-col-xs-5" style="padding-left: 10px;">
                            <p style="width: 100%;margin: 10px 0;" class="autograph">
                                <strong>{{ item.extras.createUser }}->{{ item.extras.handler }}<br>[{{item.extras.actName}}]</strong>&nbsp;
                            </p>
                        </div>
                        <div class="ant-col-xs-18">
                            <div class="approvals" style="flex-wrap: wrap;">
                                <p style="width: 100%;margin: 10px 0;" slot="content">
                                    <small>{{ moment(item.createdAt).format("YYYY年MM月DD日") }}</small>:&nbsp;
                                    {{$helper.nl2br(item.explain)}}
                                </p>
                                <template v-if="item.extras.wfCommentList">
                                    <p  v-for="mItem in item.extras.wfCommentList" :key="mItem.id" style="width: 100%;margin: 10px 0;" class="autograph">
                                        <strong>{{ mItem.userName }}</strong>&nbsp;
                                        <strong>[{{ moment(mItem.createdAt).format("YYYY年MM月DD日") }}]</strong>:&nbsp;
                                        <strong>{{$helper.nl2br(mItem.content)}}</strong>
                                    </p>
                                </template>
                            </div>
                        </div>
                    </a-list-item>
                </a-list>
            </template>
        </div>
        <div class="action">
            <a-button @click="onClose">关闭窗口</a-button>
        </div>
    </a-modal>
</template>

<script>
import qs from 'qs'
import moment from 'moment'

export default {
  name: 'WorkflowUrgencyList',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created () {
    const user = this.$ls.get('user')
  },
  mounted () {
    this.$nextTick(function () {
    })
  },
  data () {
    return {
      modalLoading: false,
      xwfState: {},
      procInsId: '',
      caseId: '',
      urgenceListData: [],
      moment
    }
  },
  watch: {},
  methods: {
    preData ($xwfState) {
      this.xwfState = $xwfState
      console.log('WorkflowUrgencyAdd xwfState:', this.xwfState)
      this.caseId = this.xwfState.caseId
      this.procInsId = this.xwfState.procInsId

      this.getUrgenceListData()
    },
    // 未知 xwfState 参数，需传业务caseId 获取xwfState
    loadXwfState ($caseId) {
      let that = this
      this.$http.get('/api/1/workflow/xwf_state.json?id=' + $caseId).then(function (response) {
        let result = response.result
        that.preData(result)
      })
    },
    getUrgenceListData () {
      let that = this
      /**
       * 获取下一步经办用户信息
       */
      that.$http.get('/api/1/workflow/urgency/get_urgency_list.json?caseId=' + that.caseId).then(function (resp) {
        if (resp.code === 200 && resp.result) {
          that.urgenceListData = resp.result
        }
        console.log('处理返回结果：', that.urgenceListData)
      })
    },
    onClose () {
      this.$emit('cancel')
    }
  }
}
</script>

<style>
    .wf-modal .ant-modal-body {
        padding: 12px !important;
    }

    .wf-card .ant-card-body {
        padding: 0 !important;
    }

    .wf-card-title {
        border-width: 1px 1px 0 1px;
        border-style: solid;
        border-color: #b2d5f2;
        background-color: #e2f2ff;
        padding: 8px;
    }

    .wf-card-body {
        height: 280px;
        overflow-y: auto;
        border: 1px solid #b2d5f2;
        padding: 5px;
    }

    .wf-cards {
        display: flex;
        flex-wrap: wrap;
    }

    .wf-modal .ant-modal-header {
        padding: 16px 24px;
        border-radius: 4px 4px 0 0;
        color: rgba(0, 0, 0, .65);
        border-bottom: 1px solid #e8e8e8;
        background: #2f7fe3;
    }

    .wf-modal .ant-modal-title {
        color: #fff;
    }

    .wf-modal .ant-modal-close-x {
        color: #fff;
    }
</style>

<style lang="less" scoped>
    .wf-cards {
        /deep/ .ant-checkbox-wrapper {
            height: auto;
            padding: 2px 0;
        }

        /deep/ .ant-radio-wrapper {
            height: auto;
            padding: 2px 0;
        }

        /deep/ .ant-radio-wrapper span {
            white-space: initial;
        }
    }

    .result {
        text-align: center;
        width: 100%;
        margin: 0 auto;
        padding: 24px 0 8px;

        .icon {
            font-size: 72px;
            line-height: 72px;
            margin-bottom: 24px;
        }

        .success {
            color: #52c41a;
        }

        .error {
            color: red;
        }

        .title {
            font-size: 24px;
            color: rgba(0, 0, 0, .85);
            font-weight: 500;
            line-height: 32px;
            margin-bottom: 16px;
        }

        .description {
            font-size: 14px;
            line-height: 22px;
            color: rgba(0, 0, 0, 0.45);
            margin-bottom: 24px;
        }

        .content {
            background: #fafafa;
            padding: 24px 40px;
            border-radius: 2px;
            text-align: left;
        }

        .fx-form-view td {
            text-align: left;
        }

    }

    .action {
        margin-top: 32px;
        text-align: right;
    }

    /deep/ .ant-modal-header {
        padding: 16px 24px;
        border-radius: 4px 4px 0 0;
        color: rgba(0, 0, 0, .65);
        border-bottom: 1px solid #e8e8e8;
        background: #2f7fe3;
    }
</style>
